import React from 'react';
import urlparam from 'urlparam';
import { connectI18n } from '../../connects';
import APIConnectionWarning from '../../elements/APIConnectionWarning/APIConnectionWarning';
import Blocklink from '../../elements/Blocklink';
import { dialogAlert } from '../../elements/Dialog/dialogs';
import Input from '../../elements/forms/Input';
import HomeLogo from '../../elements/HomeLogo';
import Scrollable from '../../elements/Scrollable';
import TopBar from '../../elements/TopBar/TopBar';
import Screen from '../Screen';

class PasswordRecover extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: urlparam('email') || '',
        };
    }
    render() {
        var i18n = this.props.i18n,
            header = (
                <>
                    <TopBar returnURL="/login/email" />
                    <HomeLogo />
                </>
            ),
            footer = <APIConnectionWarning />;

        return (
            <Screen header={header} footer={footer} className="authentication-screen">
                <Scrollable>
                    <form onSubmit={this.handleSubmit.bind(this)} action="#">
                        <h1>{i18n['label.forgotPassword']}</h1>
                        <div className="content">
                            <Input type="email" label={i18n['label.email.address']} value={this.state.email} onChange={this.handleChange.bind(this, 'email')} autoFocus />
                            <br />
                        </div>
                        <Blocklink type="submit" className="text-right" next>
                            {i18n['label.submit']}
                        </Blocklink>
                    </form>
                </Scrollable>
            </Screen>
        );
    }
    handleChange(field, value) {
        this.setState({ [field]: value });
    }
    handleSubmit(e) {
        e.preventDefault();
        this.pwdRecover();
    }
    pwdRecover() {
        if (this.state.email) {
            app.store.dispatch(app.actions.ui.busy());
            var i18n = this.props.i18n;

            app.api.session
                .recoverPassword(this.state.email)
                .then(async function () {
                    await dialogAlert(i18n['message.forgottenPasswordRecovered']);
                    app.history.push('/login/email');
                })
                .catch(async function () {
                    await dialogAlert(i18n['message.emailNotFound']);
                })
                .then(
                    function () {
                        app.store.dispatch(app.actions.ui.free());
                    }.bind(this)
                );
        }
    }
}

export default connectI18n(PasswordRecover);
